import { BERNINA_CLOUD, MELCO_CLOUD } from "../helper/commonHelper";

//export type ProductVariant = MELCO_CLOUD | "berninacloud";

export const useCurrentProductVariant = () => {
  // TO Do check url has melcoCloud or berninaCloud
  const currentUrl = window.location.href;
  console.log(currentUrl);
  const configuredProductVariant = currentUrl;

  if(currentUrl.includes("melcocloud")) {
    return MELCO_CLOUD ;

  }
  if(currentUrl.includes("berninacloud")) {
    return BERNINA_CLOUD ;

  }
  // if (allowedProductVariants.includes(configuredProductVariant)) {
  //   console.log("allowedProductVariants");
  //   return configuredProductVariant as ProductVariant;
  // }

  throw new Error(
    `Product variant incorrectly configured (${configuredProductVariant})`
  );
};
